export enum CauseAreasTabs {
  Active,
  Inactive,
  Metrics,
}
